import {Client} from "./client.model";
import {WellnessPlan} from "./wellness-plan.model";
import {VetineoVisitTypeBundle} from "./vetineo-visit-type-bundle.model";

/**
 * Reprezentuje pojedynczą usługę lub produkt dostępny w ramach aktywnego abonamentu przypisanego do użytkownika.
 * Przechowuje informacje o terminie ważności, statusie realizacji oraz powiązaniu z konkretną wizytą lub rezerwacją.
 * Służy do rozliczania ("konsumpcji") pakietów – np. "jedno z trzech szczepień w pakiecie".
 */
export class UserCarePlanItem {
  /** Unikalny identyfikator instancji usługi w planie użytkownika. */
  public uuid: string;
  public authorUUID: string;
  public editorUUID: string;
  public created: Date;
  public modified: Date;
  public deleted: Date;
  /** Data początkowa ważności danej usługi. */
  public itemStartDate: Date;
  /** Data wygaśnięcia usługi (deadline na wykorzystanie). */
  public itemExpirationDate: Date;
  /**
   * Data faktycznego wykorzystania usługi.
   * Jeśli pole jest wypełnione, oznacza to, że usługa została zużyta (zrealizowana).
   */
  public realizationDate: Date;
  public vetReservationStartDate: Date;
  /** Nazwa usługi. */
  public name: string;
  public firstName: string;
  public lastName: string;
  public description: string;
  public mobilePhone: string;
  public email: string;
  /** Czas trwania usługi w minutach. */
  public time: number;
  public type: string;
  /** ID definicji usługi w katalogu planów. */
  public carePlanServiceUUID: string;
  /** ID nadrzędnego planu użytkownika, do którego należy ten element. */
  public userCarePlanUUID: string;
  public vClient: Client;
  public wellnessPlan: WellnessPlan;
  /**
   * Powiązany typ wizyty (Bundle).
   */
  public vetineoVisitTypeBundle: VetineoVisitTypeBundle;
  public vetineoVisitTypeBundleUUID: string;
  /** ID szablonu elementu w planie wellness. */
  public wellnessPlanItemUUID: string;
  /**
   * ID rezerwacji, powiązanej z tym elementem.
   */
  public vetReservationUUID: string;
  public restoreRequestCreated: Date;
  public restoreRequestAccepted: Date;
  public restoreRequestDeclined: Date;

}

export type CountedUserCarePlanItem = UserCarePlanItem & {
  count: number;
};
